import { capitalizeWords, formatValue } from "../utils/helpers";
import { DisaggregatedMetric, MetricMetadata } from "../services/types";
import { useState } from "react";

interface MetricCardProps {
    metric: DisaggregatedMetric;
    width: string;
    metadata: MetricMetadata[] | null;
    svg?: string;
    showMetadataIcon?: boolean;
};

const MetricCardAlt = ({ metric, metadata, svg }: MetricCardProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const { id, name, versions } = metric;
    const { value, unit, percent_calc } = versions[0];

    const val = unit === "ratio" ? `${percent_calc?.n}/${percent_calc?.d}` : value; 

    const metricMetadata = metadata?.find(m => m.id === id);
    
    const definition = metricMetadata?.definition;
    const source = metricMetadata?.versions[0].source || "Unknown Source";
    const year = metricMetadata?.versions[0].year || "N/A";
    const detail = metricMetadata?.versions[0].level_of_detail || "unknown";
    const whyImportant = metricMetadata?.versions[0].why_important || "";

    return (
        <div className="border rounded-lg p-4 shadow-lg mt-4 bg-white w-80">
            <div className="flex items-center">
                {svg && <img src={svg} alt={`${name} icon`} className="w-[40px] h-[40px] text-blue-500" />}
                <p className={`font-bold ${svg ? 'ml-1' : ''}`}>{name}</p>
            </div>
            
            <h2 className="text-2xl font-bold text-port-text">
                {formatValue(val, unit, id)}
            </h2>

            {definition && (
                <p 
                    className={`text-sm text-gray-600 mt-2 ${isExpanded ? '' : 'line-clamp-2'} cursor-pointer`}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {definition}
                </p>
            )}

            <div className="text-xs mt-3">
                <p><span className="font-bold">Year:</span> {year}</p>
                <p><span className="font-bold">Source:</span> {source}</p>
                <p><span className="font-bold">Level of Detail:</span> {capitalizeWords(detail)}</p>
            </div>

            {whyImportant && (
                <div className="mt-3">
                    <details className="cursor-pointer">
                        <summary className="text-port-green text-xs font-bold">Why is this important?</summary>
                        <p className="text-xs text-gray-600 mt-1">{whyImportant}</p>
                    </details>
                </div>
            )}
        </div>
    );
};

export default MetricCardAlt;
